import AntCollapse, { type CollapseProps as AntCollapseProps } from "antd/lib/collapse";
import clsx from "clsx";

import { ChevronDown } from "@sol/uikit/core/icons/Arrows/ChevronDown";
import { ChevronUp } from "@sol/uikit/core/icons/Arrows/ChevronUp";

import styles from "./Collapse.module.css";

export type CollapseProps = AntCollapseProps & {
    /** `panel` sits on the container surface with the expand icon at the end, like a card that folds */
    variant?: "default" | "panel";
};

export const Collapse = ({ variant = "default", className, ...props }: CollapseProps) => {
    const isPanel = "panel" === variant;

    return (
        <AntCollapse
            expandIcon={({ isActive }) => (isActive ? <ChevronUp /> : <ChevronDown />)}
            expandIconPosition={isPanel ? "end" : undefined}
            className={clsx(isPanel && styles.panel, className)}
            {...props}
        />
    );
};
